import { Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { IAmenityForm, IBoondockForm, InputPlusMinusComponent } from '@curbnturf/form-helpers';
import { WheelchairInputComponent } from '../wheelchair-input/wheelchair-input.component';

@Component({
  selector: 'curbnturf-boondock-accommodations',
  templateUrl: './boondock-accommodations.component.html',
  styleUrls: ['./boondock-accommodations.component.scss'],
  standalone: true,
  imports: [InputPlusMinusComponent, WheelchairInputComponent],
})
export class BoondockAccommodationsComponent {
  @Input() form: FormGroup<IBoondockForm>;

  @Input() hideLandOwner: boolean;

  get amenities() {
    if (this.form) {
      return this.form.get('amenities') as FormArray<FormGroup<IAmenityForm>>;
    }

    return;
  }

  get landOwner() {
    if (this.form) {
      return this.form.controls.landOwner;
    }

    return;
  }

  get sizeBuses() {
    if (this.form) {
      return this.form.controls.sizeBuses;
    }

    return;
  }

  get sizeCars() {
    if (this.form) {
      return this.form.controls.sizeCars;
    }

    return;
  }

  get busCount() {
    if (this.sizeBuses) {
      return this.sizeBuses.value;
    }

    return;
  }

  get carCount() {
    if (this.sizeCars) {
      return this.sizeCars.value;
    }

    return;
  }

  updateBuses(value: number) {
    if (this.sizeBuses) {
      this.sizeBuses.setValue(value);
      this.sizeBuses.markAsDirty();
    }
  }

  updateCars(value: number) {
    if (this.sizeCars) {
      this.sizeCars.setValue(value);
      this.sizeCars.markAsDirty();
    }
  }
}
